import { capitalize } from '../capitalize';
import { defaultTo } from '../../value/defaultTo';
import { isNotNilOrEmpty } from '../../value/isNotNilOrEmpty';
/**
 * Gets an employee's full name from their preferred, first, and last name
 *
 * @category String
 * @aka getFullName
 * @param {string} preferredFirstName - Item of type any
 * @param {string} firstName - Item of type any
 * @param {string} lastName - Item of type any
 * @returns {string} - The employee's full name
 * @example
 * fullName(undefined, 'Homer', 'Simpson');
 * fullName(null, 'Homer', 'Simpson');
 * fullName('', 'Homer', 'Simpson');
 * // => 'Homer Simpson'
 *
 * fullName('Mr. Plow', 'Homer', 'Simpson');
 * // => 'Mr. Plow Simpson'
 *
 * // Edge Cases
 * fullName(undefined, undefined, 'Simpson');
 * // => 'Simpson'
 *
 * fullName(undefined, 'Homer', undefined);
 * // => 'Homer'
 *
 * fullName(undefined, undefined, undefined);
 * // => ''
 * @docgen_example
 * fullName('Mr. Plow', 'Homer', 'Simpson');
 */
export var fullName = function (preferredFirstName, firstName, lastName) { return (getFirstName(preferredFirstName, firstName) + ' ' + getLastName(lastName)).trim(); };
// Private
var getFirstName = function (preferredFirstName, firstName) { return capitalize(defaultTo(isNotNilOrEmpty(preferredFirstName) ? preferredFirstName : firstName, '')); };
var getLastName = function (lastName) { return capitalize(defaultTo(lastName, '')); };
